// config
import config from '../config';

// components
import CollabBlockStakingForm from '../components/cities/CollabBlockStakingForm';
import Container from '../components/Container';
import PageHeader from '../components/PageHeader';

// hooks
import ConnectWalletMessage from '../components/ConnectWalletMessage';
import PageSeo from '../components/PageSeo';
import { useAlgo } from '../hooks/useAlgo';

export default function Swap() {
  return (
    <div>
      <PageSeo
        title={`Collab Block Staking`}
        description='Stake your Shitty Cities, Shitty Kitties, and Collab NFTs to claim Shitty City Collab Blocks.'
      />

      <section className='pb-48 relative overflow-hidden z-50'>
        <PageHeader
          heading='Collab Block Staking'
          description='Stake your Shitty Cities, Shitty Kitties, and Collab NFTs to claim Shitty City Collab Blocks.'
          docsLink='https://docs.shittykitties.art/website-utilities/collab-block-staking'
        />

        <PageInner />
      </section>
    </div>
  );
}

const PageInner = () => {
  const { address } = useAlgo();

  if (!address) {
    return (
      <div className='flex justify-center mt-12'>
        <ConnectWalletMessage />
      </div>
    );
  }

  return (
    <Container>
      <div className='flex flex-col gap-10 mt-12'>
        {Object.values(config.collabBlocks)
          .filter((collab) => collab.isActive)
          .map((collab, index) => (
            <CollabBlockStakingForm collab={collab} key={index} />
          ))}

        <h2 className='text-2xl font-bold text-gray-500 text-center'>How does it work?</h2>
        <div className='grid grid-cols-1 md:grid-cols-4 gap-6'>
          <div className='bg-gray-900 rounded-lg p-8'>
            <p className='text-lg'>Staking will open up for 3 days. Stake 1 Shitty City, 1 Shitty Kitty, and 1 Collab NFT.</p>
          </div>
          <div className='bg-gray-900 rounded-lg p-8'>
            <p className='text-lg'>After 3 days, the staking period will lock for 3 days.</p>
          </div>
          <div className='bg-gray-900 rounded-lg p-8'>
            <p className='text-lg'>If assets are moved out of the wallet, they are disqualified.</p>
          </div>
          <div className='bg-gray-900 rounded-lg p-8'>
            <p className='text-lg'>After 3 days, every wallet that qualifies will be airdropped the new Collab Block.</p>
          </div>
        </div>
      </div>
    </Container>
  );
};
